/* unplugin-vue-components disabled */import script from "./MenuNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuNavigation.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__